import React from 'react';

function PlaygroundAppTile({className}) {
    return (
        <div className={`playground-app-tile ${className}`}>
            <div className="playground-app-tile_text">
                Download Alan AI Playground to test your Alan AI Studio Projects on your mobile device
                </div>
            <div className="playground-app-tile_btns">
                <a className="playground-app-tile_appstore-badge" href="https://apps.apple.com/ca/app/alan-playground/id1474478921" target="_blank" rel="noreferrer"></a>
                <a className="playground-app-tile_playground-badge" href="https://play.google.com/store/apps/details?id=app.alan.playground" target="_blank" rel="noreferrer"></a>
            </div>
        </div>
    );
}

export default PlaygroundAppTile;